import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import storeHelper from "./store/store-helper";
import VueCookies from "vue-cookies";
import VueSanitize from "vue-sanitize";
import VueResizedImage from "vue-resized-image";
import "../src/assets/Quill.css";
import { ApiControllerSettings } from "@infoland/iprova-api";
import i18n from "./plugins/i18n";
import Shared from "./shared";
import * as ApiProxy from "@infoland/api-proxy";
import Utils from "./utils";
import _ from "lodash";
import { AxiosError } from "axios";
import { VueMasonryPlugin } from "vue-masonry";
import MediaNotSupported from "../src/components/modules/document/MediaNotSupported";
import VueI18n, { TranslateResult } from "vue-i18n";
import PortalVue from "portal-vue";
import "./MoveableDialog/MoveableDialog";

import "leaflet/dist/leaflet.css";
import { cookies } from "./enums";

Vue.config.productionTip = false;
const defaults = VueSanitize.defaults;
defaults.allowedTags = defaults.allowedTags.concat(["img", "u", "s"]);

defaults.allowedSchemesByTag = {
    img: ["data"]
};

Vue.use(VueSanitize, defaults);
Vue.use(VueResizedImage);
Vue.use(VueMasonryPlugin);
Vue.use(PortalVue);
(window as any).Vue = Vue;

// catch API errors
window.addEventListener("afterapierror", (evt: Event) => {
    const axiosError: AxiosError = (<CustomEvent<AxiosError>>evt).detail;

    console.log(`caught ${evt.type}`, axiosError);
    // We can ignore this error when the api call is canceled in a redirect
    if (axiosError.code === "ECONNABORTED") return;

    storeHelper.siteStore.setSnackBarMessage(`Error on API call: ${axiosError.message}`, true);
});
// cath the media errors
(<any>window).mediaErrorHandler = (errorEvent: Event) => {
    const eventElement: Element = <Element>errorEvent.srcElement;
    let mediaElement: HTMLAudioElement | HTMLVideoElement;

    const mediaNotSupportedText: VueI18n.TranslateResult = i18n.t("document.mediaNotSupported");
    const downloadLinkText: VueI18n.TranslateResult = i18n.t("document.mediaDownloadLink");

    if (eventElement.tagName === "VIDEO") {
        mediaElement = <HTMLVideoElement>eventElement;
    } else if (eventElement.tagName === "AUDIO") {
        mediaElement = <HTMLAudioElement>eventElement;
    } else {
        return;
    }

    MediaNotSupported(mediaElement, mediaNotSupportedText.toString(), downloadLinkText.toString());
};

// fix for IE
if (!!(window as any).MSInputMethodContext && !!document["documentMode"]) {
    window.addEventListener("hashchange", function () {
        let target = window.location.hash;
        router.push(target.substring(1, target.length)).catch(err => {});
    });
}

// function to start app
(window as any).Portal = function (elementSelector: string, iProvaUrl: string, loginCookie: string) {
    //remove trailing / if needed
    Shared.iProvaUrl = iProvaUrl.replace(/\/$/, "");

    // setup API-controller
    ApiControllerSettings.iProvaApiUrl = Shared.iProvaApiUrl;
    ApiProxy.ApiControllerSettings.iProvaApiUrl = Shared.iProvaApiUrl;

    // setup store
    storeHelper.init(store);

    //arrange read only mode
    let read_only_mode: boolean;
    storeHelper.settingsStore.getSettingAsync<boolean>("read_only_mode").then(value => {
        read_only_mode = value;
    });
    Vue.mixin({
        computed: {
            $user: () => storeHelper.userStore.loggedOnUser,
            $readOnlyMode: () => read_only_mode,
            $dialogPortal: () => "dialogsPortal"
        },
        methods: {
            $confirm(title: TranslateResult, message: TranslateResult) {
                return (this.$root as any).confirm?.(title, message);
            }
        }
    });

    Vue.use(VueCookies);
    Vue.$cookies.config(Infinity, null, null, Shared.iProvaUrl.startsWith("https://"), Utils.GetSameSiteValue());

    if (loginCookie) {
        console.log("Setting logon cookie", loginCookie, cookies.iProva_LoginRedirect);
        Utils.setCookie(cookies.iProva_LoginRedirect, loginCookie, true);
    }

    return new App({
        el: elementSelector,
        i18n,
        vuetify,
        router,
        store
    });
};
